import { z } from 'zod';

/** Supplier form; lead time is typed as text so the field can be left blank. */
export const supplierSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, { error: 'diamonds:validation.required' })
    .max(120, { error: 'diamonds:validation.tooLong' }),
  currency: z
    .string()
    .trim()
    .toUpperCase()
    .regex(/^[A-Z]{3}$/, { error: 'diamonds:validation.currency' }),
  leadTimeDays: z
    .string()
    .trim()
    .refine((v) => v === '' || (/^\d+$/.test(v) && Number(v) <= 365), {
      error: 'diamonds:validation.leadTime',
    }),
  notes: z.string().max(2000, { error: 'diamonds:validation.tooLong' }),
});

export type SupplierInput = z.input<typeof supplierSchema>;
export type SupplierValues = z.output<typeof supplierSchema>;

/** CSV upload: the supplier the rows belong to; the file is read in the browser. */
export const importSchema = z.object({
  supplierId: z.string().min(1, { error: 'diamonds:validation.supplier' }),
});

export type ImportValues = z.infer<typeof importSchema>;
